let cleanupScroll = null

document.addEventListener("turbo:load", () => {
  const button = document.querySelector('[aria-controls="mobile-menu"]')
  if (!button) return

  const menu = document.getElementById("mobile-menu")
  const header = document.getElementById("site-header")
  if (!menu) return

  const focusableSelector = 'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'

  // Mobile menu toggle with max-height animation
  button.addEventListener("click", () => {
    const isOpen = menu.style.maxHeight && menu.style.maxHeight !== "0px"

    if (isOpen) {
      menu.style.maxHeight = "0px"
      button.setAttribute("aria-expanded", "false")
    } else {
      menu.style.maxHeight = menu.scrollHeight + "px"
      button.setAttribute("aria-expanded", "true")

      // Move focus into menu when opening
      const firstLink = menu.querySelector(focusableSelector)
      if (firstLink) firstLink.focus()
    }
  })

  // Close on Escape and return focus to toggle button
  menu.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      menu.style.maxHeight = "0px"
      button.setAttribute("aria-expanded", "false")
      button.focus()
      return
    }

    // Focus trap: cycle Tab within menu
    if (e.key === "Tab") {
      const focusable = [...menu.querySelectorAll(focusableSelector)]
      if (focusable.length === 0) return

      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }
  })

  // Sticky header scroll shadow
  if (header) {
    if (cleanupScroll) cleanupScroll()

    const onScroll = () => {
      if (window.scrollY > 10) {
        header.classList.add("shadow-soft")
      } else {
        header.classList.remove("shadow-soft")
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()

    cleanupScroll = () => {
      window.removeEventListener("scroll", onScroll)
      cleanupScroll = null
    }
  }
})

document.addEventListener("turbo:before-cache", () => {
  if (cleanupScroll) cleanupScroll()
})
